import * as React from 'react'

const GreenSuccess = props => (
  <svg width={28} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m2 9.545 8.3 8.299L26.142 2" stroke="#26C36F" strokeWidth={4} />
  </svg>
)

export default GreenSuccess
